import PropType from 'prop-types';
import { UNIT_TYPE } from 'util/config/constant';
import { UtilisationCleaningGraph } from './components';

const MachineUtilisationCleaning = ({ unit, data, time, isLoading }) => {
  const unitType =
    unit === UNIT_TYPE.hours ? UNIT_TYPE.hours : UNIT_TYPE.cleanedSquareMeter;
  const totalValue = data.reduce((accumulator, item) => {
    return accumulator + item.maxStatistics[unitType];
  }, 0);

  return (
    <div className="machine-utilisation-cleaning">
      {data?.map((item) => (
        <UtilisationCleaningGraph
          key={item.name + unit}
          totalValue={totalValue}
          item={item}
          unit={unit}
          time={time}
          isLoading={isLoading}
        />
      ))}
    </div>
  );
};

export default MachineUtilisationCleaning;

MachineUtilisationCleaning.propTypes = {
  unit: PropType.string.isRequired,
  time: PropType.string.isRequired,
  isLoading: PropType.bool.isRequired,
  data: PropType.arrayOf(PropType.shape()).isRequired
};
